import React from 'react';
import cn from 'classnames';
import styles from "./FilterPickerGroup.module.scss";
import { TextButton } from "../TextButton";
export function FilterPickerGroup(props) {
  const {
    className,
    style,
    children,
    flexWrap,
    onClearClick,
    disableClear
  } = props;
  const testId = props['data-testid'];
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: cn(styles.root, {
      [styles.flexWrap]: flexWrap
    }, className),
    "data-testid": testId
  }, children, onClearClick ? /*#__PURE__*/React.createElement(TextButton, {
    onClick: onClearClick,
    skin: "secondary",
    disabled: disableClear,
    "data-testid": "".concat(testId, "-clear")
  }, "Clear") : null);
}